import { Spinner } from "@heroui/react";
import { AnimatePresence, motion } from "framer-motion";

export const LoadingOverlay = ({
  visible,
  children,
}: {
  visible: boolean;
  children?: React.ReactNode;
}) => {
  if (!visible) return null;

  return (
    <AnimatePresence>
      {visible ? (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 0.75 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2, delay: 0.2 }}
          className="bg-background absolute top-0 left-0 z-999999999 flex h-full w-full items-center justify-center"
        >
          {children ? children : <Spinner size="lg" />}
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
};
